module.exports = __webpack_public_path__ + "static/media/Summum.43bc948d.jpg";